import { PHONE_MASKED_REGEXP, REPEATED_DIGITS_REGEXP } from 'app-constants'

export function formatPhone(phone = '') {
  const onlyDigit = phone?.toString()?.replace(/\D/g, '')

  const formated = onlyDigit?.replace(/(\d{2})(\d)/, '($1) $2')

  return onlyDigit?.length < 11
    ? formated?.replace(/(\d{4})(\d)/, '$1-$2')
    : formated?.replace(/(\d{5})(\d)/, '$1-$2')
}

export function formatPhoneMasked(phone = '') {
  const formatted = formatPhone(phone)

  return formatted.replace(
    PHONE_MASKED_REGEXP,
    (_, ddd, middle, rest) => `${ddd}${'X'.repeat(middle.length)}-${rest}`
  )
}

export function formatPhoneToDB(phone) {
  return phone.replace(/[() -]/g, '')
}

export function isPhoneValid(phone) {
  if (!phone) return false

  const unmaskedPhone = formatPhoneToDB(phone)

  const phoneLength = unmaskedPhone.length
  const isSizeValid = phoneLength >= 10 && phoneLength <= 11
  const areNumbersRepeated = REPEATED_DIGITS_REGEXP.test(unmaskedPhone)
  const areNumbersSequential = '12345678910'.includes(unmaskedPhone)

  const phoneWithoutPrefix = unmaskedPhone.slice(2)
  const areNumbersRepetedWithoutPrefix = REPEATED_DIGITS_REGEXP.test(phoneWithoutPrefix)
  const areNumbersSequentialWithoutPrefix = '12345678910'.includes(phoneWithoutPrefix)

  if (
    !isSizeValid ||
    areNumbersRepeated ||
    areNumbersSequential ||
    areNumbersRepetedWithoutPrefix ||
    areNumbersSequentialWithoutPrefix
  )
    return false

  return true
}
